import { useState, useEffect } from 'react';

type DimensionType = 'screen' | 'window';

function getDimensions(type: DimensionType) {
  if (type === 'screen') {
    return {
      width: screen.width,
      height: screen.height,
      orientation: screen.orientation,
    };
  }

  return {
    width: window.innerWidth,
    height: window.innerHeight,
    orientation: screen.orientation,
  };
}

export function useDimension(type: DimensionType = 'window') {
  const [dimensions, setDimensions] = useState(getDimensions(type));

  useEffect(() => {
    function handleResize() {
      setDimensions(getDimensions(type));
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [type]);

  return { ...dimensions };
}
